<mat-card class="mcd-card view-all-detail-card">
  <mat-card-header class="mcd-card-header-dateModified">
    <mat-card-title style="font-weight: bold">
      <button
        style="
          background-color: #3f51b51a;
          color: #3f51b5;
          border: none;
          padding: 5px 11px;
          border-radius: 4px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
        "
        (click)="goBack()"
      >
        <img src="/assets/images/back to list.svg" />
        Back
      </button>
      <span>
        <img
          src="/assets/images/equipment standard.svg"
          style="margin-left: 16px; margin-right: 8px"
        />  
      </span>
      <span style="font-size: 16px;">View Upcoming Equipment Standard</span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mcd-card-content grbes-view">
    <div style="padding: 20px; background-color: #f7f9fa">
      <div class="review-page-container" *ngIf="!loading && grsDetail?.standard">
        <!-- Breadcrumb & Sharing Bar -->
        <div class="breadcrumbs clearfix">
          <div class="breadcrumbs-inner">
            <ul>
              <li>
                <a routerLink="/view-all-upcoming-standards-list" routerLinkActive="active"
                  >All</a
                >
              </li>
              <li class="separator">/</li>
              <li class="active">
                {{ grsDetail.standard.equipmentStandard?.model || grsDetail.standard.title }}
              </li>
              <li
                style="
                  float: right;
                  border: 1px solid #3f51b5;
                  padding: 6px 10px;
                  border-radius: 4px;
                "
              >
                <img
                  src="/assets/images/social-sharing 1.svg"
                  style="margin-right: 4px"
                />

                <a
                  style="color: #3F51B5; text-decoration: none; cursor: pointer; font-weight: 700;"
                  (click)="openShareModal()"
                  >Share
                </a>
              </li>
              <li
                style="
                  float: right;
                  border: 1px solid #3f51b5;
                  padding: 6px 10px;
                  border-radius: 4px;
                  margin-right: 10px;
                "
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-bottom: 2px; margin-right: 2px"
                >
                  <path
                    d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                    stroke="#3C74E0"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <a
                  style="color: #3F51B5; text-decoration: none; cursor: pointer; font-weight: 700;"
                  (click)="downloadExcel()"
                  >Download Standard
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="breadcrumbs clearfix"></div>

        <!-- 2 Column Layout -->
        <div style="display: flex; gap: 40px">
          <!-- Left Column Image Box -->
          <div
            style="
              width: 431px;
              border: 1px solid #ffebb7;
              padding: 16px 24px 24px 24px;
              border-radius: 8px;
              align-content: center;
              gap: 8px;
            "
          >
            <div
              style="
                width: 383px;
                height: 32px;
                margin-bottom: 10px;
              "
            >
              <img
                [src]="
                  grsDetail?.standard?.equipmentStandard?.supplier
                    ?.supplierLogoAttachment?.image
                "
                style="
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  border-radius: 4px;
                "
              />
            </div>
            <div
              style="
                width: 383px;
                height: 383px;
                margin: auto;
              "
            >
              <img
                [src]="
                  grsDetail?.standard?.equipmentStandard?.imageAttachment?.image
                "
                style="
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 4px;
                "
              />
            </div>
          </div>

          <!-- Right Column Metadata Grid -->
          <div class="info-main">
            <div>
              <h1 class="lastpage-title" style="padding: 8px">
                {{ grsDetail.standard.title }}
              </h1>
            </div>
            <div class="info-section">
              <div class="info-column right-column">
                <div class="info-row">
                  <span class="reviewPage-icon date"></span>
                  <span class="label">Approved For Use</span>
                  <span class="value">{{
                    grsDetail.standard.effectiveFrom != null
                      ? (grsDetail.standard.effectiveFrom
                        | date: "dd, MMM yyyy")
                      : "--"
                  }}</span>
                </div>

                <div class="info-row">
                  <span class="reviewPage-icon date2"></span>
                  <span class="label">Obsolete Date</span>
                  <span class="value">{{
                    grsDetail.standard.equipmentStandard?.obsoleteDate != null
                      ? (grsDetail.standard.equipmentStandard.obsoleteDate
                        | date: "dd, MMM yyyy")
                      : "--"
                  }}</span>
                </div>

                <div class="info-row">
                  <span class="reviewPage-icon equipmentType"></span>
                  <span class="label">Equipment Type</span>
                  <span class="value">{{
                    grsDetail.standard.equipmentStandard?.equipmentType?.name || "--"
                  }}</span>
                </div>
                <div class="info-row">
                  <span class="reviewPage-icon equipmentClass"></span>
                  <span class="label">Equipment Class</span>
                  <span class="value">{{
                    grsDetail.standard.equipmentStandard?.equipmentClassType?.name || "--"
                  }}</span>
                </div>
                <div class="info-row">
                  <span class="reviewPage-icon supplier"></span>
                  <span class="label">Supplier</span>
                  <span class="value">{{
                    grsDetail.standard.equipmentStandard?.supplier?.name || "--"
                  }}</span>
                </div>

                <div class="info-row">
                  <span class="reviewPage-icon model"></span>
                  <span class="label">Model</span>
                  <span class="value">{{
                    grsDetail.standard.equipmentStandard?.model || "--"
                  }}</span>
                </div>
                <div class="info-row">
                  <span class="reviewPage-icon location"></span>
                  <span class="label">Location</span>
                  <span class="value">{{ allLocations || "--" }}</span>
                </div>

                <div class="info-row">
                  <span class="reviewPage-icon Sublocation"></span>
                  <span class="label">Sub Location</span>
                  <span class="value">{{
                    subLocations ? subLocations : "--"
                  }}</span>
                </div>

                <div class="info-row">
                  <span class="reviewPage-icon createdOn"></span>
                  <span class="label">Last Updated</span>
                  <span class="value">{{
                    grsDetail.standard.lastModifiedDate != null
                      ? (grsDetail.standard.lastModifiedDate | date: "dd, MMM yyyy")
                      : "--"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description Section -->
        <div class="description-section">
          <div
            style="display: flex; align-items: center; align-content: center"
          >
            <h2 class="section-title">Description</h2>
            <button class="copyIcon">
              <img
                (click)="
                  copyText(grsDetail.standard.description);
                  $event.stopPropagation()
                "
                src="../../assets/images/copy text.svg"
                alt="Copy"
              />
            </button>
          </div>
          <p class="description-text">
            {{ grsDetail.standard.description }}
          </p>
        </div>

        <!-- Accordion Details Section -->
        <div class="details-section" style="margin-top: 20px" *ngIf="grsDetail.standard.note">
          <div class="details-header" (click)="toggleDetails()">
            <div class="details-title-wrapper">
              <div>
                <span class="toggle-icon">
                  <img
                    *ngIf="!detailsExpanded"
                    src="../../assets/images/s-add 1.svg"
                    alt="Expand"
                    style="margin-bottom: 3px" />
                  <img
                    *ngIf="detailsExpanded"
                    src="../../assets/images/cross (2).svg"
                    alt="Collapse"
                    style="margin-bottom: 3px"
                /></span>
                <span class="details-title" [ngClass]="{ 'details-title-expanded': detailsExpanded }"> Details </span>
              </div>
              <div *ngIf="detailsExpanded">
                <img
                  (click)="
                    copyText(grsDetail.standard.note); $event.stopPropagation()
                  "
                  src="../../assets/images/copy text.svg"
                  alt="Copy"
                />
              </div>
            </div>
          </div>

          <div class="details-content" [class.expanded]="detailsExpanded">
            <div [innerHTML]="grsDetail.standard.note" class="detail-section"></div>
          </div>
        </div>

        <!-- Resources and Supporting Information -->
        <div
          *ngIf="
            linksList?.length > 0 ||
            grsDetail?.standard?.equipmentStandard?.equipmentAttachment?.id != null
          "
          class="bottom-sections single-column"
        >
          <div
            class="resources-section"
            *ngIf="linksList?.length > 0 || grsDetail?.standard?.equipmentStandard?.equipmentAttachment?.id != null"
          >
            <div class="section-header">
              <h2 class="section-heading">
                Resources and Supporting Information
              </h2>
              <span
                matTooltip="Information about Resources and Supporting Information"
                style="
                  background-image: url(&quot;/assets/images/Vector.svg&quot;);
                  background-repeat: no-repeat;
                  background-size: auto;
                  background-position: center;
                  padding: 10px;
                "
              ></span>
            </div>
            <div class="links-list">
              <a
                href="javascript:void(0);"
                *ngIf="grsDetail?.standard?.equipmentStandard?.equipmentAttachment?.id != null"
                (click)="onDownloadSelectedEquipmentAttachment(grsDetail.standard.equipmentStandard.equipmentAttachment)"
              >
                <img src="/assets/images/attachement.svg" />
                {{ grsDetail.standard.equipmentStandard.equipmentAttachment.fileName }}
              </a>
              <a
                *ngFor="let link of linksList"
                [href]="link.url"
                class="resource-link"
                target="_blank"
              >
                {{ link.title }}
              </a>
            </div>
          </div>
        </div>

        <!-- Next / Previous Standard Buttons -->
        <div class="btn-wrapper" style="display: flex; gap: 20px; margin-top: 30px;">
          <div class="prev-button" *ngIf="!grsDetail.isFirst">
            <a
              class="nextPrevButtons"
              href="javascript:void(0)"
              (click)="slide(grsDetail.standard.id, false)"
            >
              <img src="/assets/images/arrow-right 2.svg" />
              Previous Standard
            </a>
          </div>
          <div class="next-button" *ngIf="!grsDetail.isLast">
            <a
              class="nextPrevButtons"
              href="javascript:void(0)"
              (click)="slide(grsDetail.standard.id, true)"
            >
              Next Standard
              <img src="/assets/images/arrow-right 1 (2).svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  </mat-card-content>
</mat-card>
<app-share-link-modal
  *ngIf="isShareModalOpen"
  [itemTitle]="shareModalTitle"
  [itemSubtitle]="shareModalSubtitle"
  [shareUrl]="shareModalUrl"
  (closeModal)="isShareModalOpen = false"
></app-share-link-modal>
